import { KeyValueModel } from "@models/common";

export * from "./legend";
export * from "./state-map-request";
export * from "./state-map-response";
export * from "./area-detail";
export * from "./json-shape-urls";
export * from "./shape-color-options";
export * from "./map-program";
export * from "./area-map-request";
export * from "./area-map-response";

export enum MapType {
    State = 1,
    Poverty = 2,
    RaceEthnicity = 3,
    EducationalAttainment = 4,
    Employment = 5,
    Housing = 6
}

export enum RaceEthnicityMapFilter {
    Year = 'raceEthnicityYear',
    Race = 'raceEthnicityRace',
    Age = 'raceEthnicityAge',    
    Sex = 'raceEthnicitySex',
}

export enum EducationalAttainmentMapFilter {
    Year = 'educationalAttainmentYear'
}

export enum EmploymentMapFilter {
    Year = 'employmentYear',
    Field = 'employmentField',
}

export enum HousingMapFilter {
    Field = 'housingField',
}

export enum PovertyMapFilter {
    Age = 'povertyAge',
    Type = 'povertyType'
}

export class AdditionalMapFilter {
    public label: string;
    public key: string;
    public options: KeyValueModel[];
    public defaultValue: string = '';
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/index.ts